import React from 'react';

import { ApiProductOption } from '~/types/Product';

interface Props {
  options: ApiProductOption[];
  selectedValues: Record<string, string>;
  onChange: (_optionCode: string, _valueCode: string) => void;
}

const ProductOptionSelector: React.FC<Props> = ({ options, selectedValues, onChange }) => {
  return (
    <>
      {options.map((opt) => {
        const selectedValue = (opt.values ?? []).find((v) => v.code === selectedValues[opt.code]);

        return (
          <div className="mb-2" key={opt.code}>
            <p className="form-label mb-2 fw-normal">
              <span className="fw-semibold">{opt.name}:</span>{' '}
              <span className="text-gray-600 ms-2">{selectedValue?.value}</span>
            </p>
            <div className="d-flex align-items-center flex-wrap gap-2" role="group" aria-label={opt.name}>
              {(opt.values ?? []).map((v) => {
                const isSelected = selectedValues[opt.code] === v.code;
                const inputId = `${opt.code}-${v.code}`;

                return (
                  <React.Fragment key={v.code}>
                    <input
                      type="radio"
                      className="btn-check"
                      name={opt.code}
                      id={inputId}
                      checked={isSelected}
                      onChange={() => onChange(opt.code, v.code)}
                    />
                    {v.colorType ? (
                      <label
                        className="btn btn-outline-primary btn-options btn-options--color"
                        htmlFor={inputId}
                        aria-label={v.value}
                      >
                        <span className="color-indicator" style={{ backgroundColor: v.colorType }} />
                      </label>
                    ) : (
                      <label className="btn btn-outline-primary btn-options" htmlFor={inputId}>
                        {v.value}
                      </label>
                    )}
                  </React.Fragment>
                );
              })}
            </div>
          </div>
        );
      })}
    </>
  );
};

export default ProductOptionSelector;
